/* eslint-disable */

/** unique or primary key constraints on table "argo.work_instruction_version" */
export enum ArgoWorkInstructionVersionConstraint {
  /** unique or primary key constraint on columns "work_instruction_version_id" */
  ArgoWorkInstructionVersionPkey = 'argo_work_instruction_version_pkey',
  /** unique or primary key constraint on columns "work_instruction_id" */
  ArgoWorkInstructionVersionUniqueActiveVersion = 'argo_work_instruction_version_unique_active_version',
  /** unique or primary key constraint on columns "version_number", "work_instruction_id" */
  ArgoWorkInstructionVersionUniqueVersionNumber = 'argo_work_instruction_version_unique_version_number'
}

/** select columns of table "argo.work_instruction_version" */
export enum ArgoWorkInstructionVersionSelectColumn {
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DiscontinueAfter = 'discontinue_after',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number',
  /** column name */
  WorkInstructionId = 'work_instruction_id'
}

/** update columns of table "argo.work_instruction_version" */
export enum ArgoWorkInstructionVersionUpdateColumn {
  /** column name */
  ApprovedById = 'approved_by_id',
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DiscontinueAfter = 'discontinue_after',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  VersionNumber = 'version_number',
  /** column name */
  WorkInstructionId = 'work_instruction_id'
}

